import React, {Component} from "react";
import { Line } from 'react-chartjs-2';

export const DEFAULT_LINE_COLOR = '#3799FF';
export const DISABLED_LINE_COLOR = '#EEEEEE';

type DataValues = (number|null)[]|{[index:string]:any}[];
type DataSet = DataValues|{lineColor?: string|string[], pointColor?: string|string[], data: DataValues};

interface LineChartProps {
  data: DataSet[],
  xAxis: {labels: string[]}
}

export default class LineChart extends Component<LineChartProps, {}> {
  static formatDataSet(dataSet: DataSet) {
    if(Array.isArray(dataSet)) {
      return {
        data: dataSet,
        borderColor: DEFAULT_LINE_COLOR,
        pointBorderColor: DEFAULT_LINE_COLOR,
        pointBackgroundColor: DEFAULT_LINE_COLOR
      };
    } else {
      const dataSetOptions: any = {
        data: dataSet.data,
        borderColor: DEFAULT_LINE_COLOR,
        pointBorderColor: dataSet.pointColor || DEFAULT_LINE_COLOR,
        pointBackgroundColor: dataSet.pointColor || DEFAULT_LINE_COLOR
      };
      if(Array.isArray(dataSet.lineColor)) {
        const lineColors: string[] = dataSet.lineColor;
        dataSetOptions.segment = {
          borderColor: (ctx: any) => lineColors[ctx.p0['$context'].dataIndex]
        };
      } else {
        dataSetOptions.borderColor = dataSet.lineColor;
      }
      return dataSetOptions;
    }
  }

  render() {
    const data = {
      labels: this.props.xAxis.labels,
      datasets: this.props.data.map(LineChart.formatDataSet)
    };
    const options = {
      plugins: {
        legend: {
          display: false
        }
      }
    };
    return <div className="chart line-chart">
      <Line type="line" data={data} options={options} />
    </div>;
  }
}